//@ts-check
import React from 'react';
/**@type {import('../types').DataType<import('./types').TaskModel>} */

var TASK_DATA_TYPE = {
  data: {
    url: '/backend/tasks',
    dataKey: 'tasks'
  },
  placeholders: {
    label: function label(data) {
      return data.Title;
    },
    type: function type() {
      return 'environment';
    },
    icon: function icon() {
      return 'environment';
    },
    name: function name(data) {
      return data.Title;
    }
  }
};
export default TASK_DATA_TYPE;